export default __webpack_public_path__ + "static/media/funds__hero--portal.f3f704c5.png";